<template>
  <el-select
    v-model="value"
    :disabled="disabled"
    :clearable="clearable"
    @update:modelValue="update"
    @clear="clear"
  >
    <el-option
      v-for="item in items"
      :key="item.id"
      :label="item.attributes.name"
      :value="item.id"
    >
      {{ item.attributes.name }}
    </el-option>
  </el-select>
</template>

<script lang="ts">
import { defineComponent, watch, ref } from 'vue'

export default defineComponent({
  name: 'SpotListSelect',
  props: {
    modelValue: {
      required: true,
      type: String
    },
    clearable: {
      type: Boolean,
      default: true
    },
    items: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const defaultProps = { ...props }

    const update = function (newValue: any) {
      if (props.multiple) {
        context.emit(
          'update:modelValue',
          newValue.map((x: any) => String(x))
        )
      } else {
        context.emit('update:modelValue', String(newValue))
      }
    }

    const clear = () => {
      update('')
      context.emit('clear')
    }
    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )
    watch(
      (_: any) => props.items,
      (_: any) => update(defaultProps.modelValue)
    )

    return { update, clear, value }
  }
})
</script>
